/**
 * AI provider/source identifiers, mirrored from the backend's
 * AiProvider / AiSource enums.
 *
 * Provider = company / API service offering the model
 *   Used in: result.provider, API JSON keys, DB persistence
 *
 * Source = AI model family that produced a recommendation/pattern
 *   Used in: pattern.source, trade.source, byAI map keys, filters,
 *   followedRecommendation
 */
export const AI_PROVIDER = Object.freeze({
  ANTHROPIC: 'anthropic',
  OPENAI: 'openai',
});

export const AI_SOURCE = Object.freeze({
  CLAUDE: 'claude',
  GPT: 'gpt',
  BOTH: 'both',
  MANUAL: 'manual',
});
